import React, { useState } from "react";
import { tokens } from "../../../../../../theme";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDate, useInput } from "./hooks/useInput";
import { useEnterprise } from "./hooks/useEnterprise";
import { useFetchEnterprise } from "./hooks/useFetchEnterprise";
import { useFetchEmployees } from "./hooks/fetch/useFetchEmployee";
import { useFetchAddress } from "./hooks/fetch/useFetchAddress";
import { useFetchRoutes } from "./hooks/fetch/useFetchRoutes";
import { useCoordinate } from "./hooks/useCoordinate";
import { useFetchVehicle } from "./hooks/fetch/useFetchModel";
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileTimePicker,
} from "@mui/x-date-pickers";
import { useCheckbox } from "./hooks/useCheckbox";

const BookingBusinessTest = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  const persons = useInput({ type: "number", name: "persons" });
  const priceDriver = useInput({ type: "number", name: "priceDriver" });
  const tax = useInput({ type: "number", name: "tax" });
  const priceTotal = useInput({ type: "number", name: "priceTotal" });
  const vehicleSelect = useInput({ type: "text", name: "vehicle" });
  const booking = useInput({ type: "text", name: "booking" });
  const date = useDate({ type: "text", name: "date" });
  const time = useDate({ type: "text", name: "time" });
  const dateEnd = useDate({ type: "text", name: "dateEnd" });
  const timeEnd = useDate({ type: "text", name: "dateEnd" });
  const notes = useInput({ type: "text", name: "notes" });

  const quote = useCheckbox();
  const phoneActive = useCheckbox();

  const enterprise = useEnterprise({ name: "enterprise" });

  const enterprises = useFetchEnterprise();
  const resp = useFetchEmployees(enterprise.id);
  const address = useFetchAddress(enterprise.id);
  const routes = useFetchRoutes(enterprise.id);
  const model = useFetchVehicle();

  const [employee, setEmployee] = useState([]);
  const origin = useCoordinate();
  const destination = useCoordinate();

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(persons.value);
    console.log(tax.value);
    console.log(priceTotal.value);
    console.log(quote.checked);
    console.log(phoneActive.checked);
  };

  return (
    <form
      style={{ backgroundColor: `${colors.primary[400]}` }}
      onSubmit={handleSubmit}
    >
      <Box backgroundColor={colors.primary[400]} p={2} sx={{ margin: "1px" }}>
        <Grid container spacing={1.5} sx={{ alignItems: "center" }}>
          <Grid item xs={12} md={6}>
            {enterprises.value ? (
              <Autocomplete
                id="autocomplete-enterprise"
                {...enterprise}
                disablePortal
                options={enterprises.value}
                getOptionLabel={(option) =>
                  `${option.commertial_name} - ${option.ruc} - ${option.business_name}`
                }
                renderInput={(params) => (
                  <TextField {...params} label={"Empresas"} />
                )}
              />
            ) : (
              <TextField
                fullWidth
                disabled
                type="text"
                label={"Lista de Empresas"}
              />
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            {resp ? (
              <Autocomplete
                value={employee}
                disablePortal
                name="client"
                id="combo-box-client"
                onChange={(e, newValue) => {
                  setEmployee(newValue);
                }}
                options={resp}
                getOptionLabel={(option) =>
                  `${option.name} ${option.lastname} - ${option.phone} - ${option.subrole_name}`
                }
                renderInput={(params) => (
                  <TextField {...params} label={"Empleados"} />
                )}
              />
            ) : (
              <TextField
                fullWidth
                disabled
                type="text"
                label={"Lista de Empleados"}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            {address ? (
              <Autocomplete
                disablePortal
                name="addressOrigin"
                id="combo-box-origin"
                {...origin}
                options={address}
                getOptionLabel={(option) =>
                  `${option.name} ${option.url_address}`
                }
                renderInput={(params) => (
                  <TextField {...params} label={"Origen"} />
                )}
              />
            ) : (
              <TextField
                fullWidth
                disabled
                type="text"
                label={"Lista de Direcciones"}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            {address ? (
              <Autocomplete
                disablePortal
                name="addressOrigin"
                id="combo-box-origin"
                {...destination}
                options={address}
                getOptionLabel={(option) =>
                  `${option.name} ${option.url_address}`
                }
                renderInput={(params) => (
                  <TextField {...params} label={"Destino"} />
                )}
              />
            ) : (
              <TextField
                fullWidth
                disabled
                type="text"
                label={"Lista de Direcciones"}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField {...persons} fullWidth label={"persons"} />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>VEHICULO</InputLabel>
              <Select label="VEHICULO" id="vehicle" {...vehicleSelect}>
                {model.map((model, index) => (
                  <MenuItem key={index} value={model.id}>
                    {model.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            sm={booking.value === 3 ? 4 : 6}
            md={booking.value === 3 ? 4 : 6}
          >
            <FormControl fullWidth>
              <InputLabel>{"Para:"}</InputLabel>
              <Select id="booking" {...booking} label={"Para:"}>
                <MenuItem value={1}>{"AHORA"}</MenuItem>
                <MenuItem value={2}>{"DESPUES"}</MenuItem>
                <MenuItem value={3}>{"POR HORA"}</MenuItem>
                <MenuItem value={4}>{"TOUR"}</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={6}
            sm={booking.value === 3 ? 2 : 3}
            sx={{
              display: {
                xs: booking.value != 1 ? "block" : "none",
                md: booking.value != 1 ? "block" : "none",
              },
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileDatePicker
                  label={booking.value === 3 ? "Fecha Inicio" : "Fecha"}
                  inputFormat="DD/MM/YYYY"
                  {...date}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid
            item
            xs={6}
            sm={booking.value === 3 ? 2 : 3}
            sx={{
              display: {
                xs: booking.value != 1 ? "block" : "none",
                md: booking.value != 1 ? "block" : "none",
              },
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={3}>
                <MobileTimePicker
                  label={booking.value === 3 ? "Hora Inicio" : "Hora"}
                  {...time}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid
            item
            xs={6}
            sm={2}
            sx={{
              display: {
                xs: booking.value === 3 ? "block" : "none",
                md: booking.value === 3 ? "block" : "none",
              },
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={2}>
                <MobileDatePicker
                  label={"Fecha Fin"}
                  inputFormat="DD/MM/YYYY"
                  {...dateEnd}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid
            item
            xs={6}
            sm={2}
            sx={{
              display: {
                xs: booking.value === 3 ? "block" : "none",
                md: booking.value === 3 ? "block" : "none",
              },
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Stack spacing={3}>
                <MobileTimePicker
                  label={"Hora Fin"}
                  {...timeEnd}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
          </Grid>

          <Grid item xs={12}>
            <TextField
              {...notes}
              fullWidth
              label={"Notas"}
              inputProps={{ style: { textTransform: "uppercase" } }}
            />
          </Grid>

          {!matchesSM && (
            <>
              <Grid item xs={2} sm={1}>
                <Checkbox {...quote} color="success" />
              </Grid>
              <Grid item xs={2} sm={1}>
                <Checkbox {...phoneActive} color="success" />
              </Grid>
            </>
          )}

          <Grid item xs={4} sm={2}>
            <TextField fullWidth {...priceDriver} label={"Conductor"} />
          </Grid>
          <Grid item xs={4} sm={2}>
            <TextField fullWidth {...tax} label={"Impuesto"} />
          </Grid>
          <Grid item xs={4} sm={2}>
            <TextField fullWidth label={"Total"} {...priceTotal} />
          </Grid>

          {matchesSM && (
            <Grid item xs={1} sm={1} marginLeft={-1}>
              <Checkbox {...quote} color="success" />
            </Grid>
          )}

          <Grid item xs={10} sm={4}>
            <Button
              fullWidth
              type="submit"
              color="secondary"
              variant="contained"
              sx={{ height: 45 }}
            >
              &#128196;&nbsp; GUARDAR&nbsp; &#128241;
              {/* &nbsp;&#128231; */}
            </Button>
          </Grid>
          {matchesSM && (
            <Grid item xs={1} sm={1}>
              <Checkbox {...phoneActive} color="success" />
            </Grid>
          )}
        </Grid>
      </Box>
    </form>
  );
};

export default BookingBusinessTest;
